// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SizeGuideRouteImport } from './routes/size-guide'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CareRouteImport } from './routes/care'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JournalIndexRouteImport } from './routes/journal.index'
import { Route as ProductHandleRouteImport } from './routes/product.$handle'
import { Route as LegalTermsRouteImport } from './routes/legal.terms'
import { Route as LegalShippingRouteImport } from './routes/legal.shipping'
import { Route as LegalReturnsRouteImport } from './routes/legal.returns'
import { Route as LegalPrivacyRouteImport } from './routes/legal.privacy'
import { Route as JournalSlugRouteImport } from './routes/journal.$slug'

const SizeGuideRoute = SizeGuideRouteImport.update({
            id: '/size-guide',path: '/size-guide',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CareRoute = CareRouteImport.update({
            id: '/care',path: '/care',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const JournalIndexRoute = JournalIndexRouteImport.update({
            id: '/journal/',path: '/journal/',getParentRoute: () => rootRouteImport
          })
const ProductHandleRoute = ProductHandleRouteImport.update({
            id: '/product/$handle',path: '/product/$handle',getParentRoute: () => rootRouteImport
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/legal/terms',path: '/legal/terms',getParentRoute: () => rootRouteImport
          })
const LegalShippingRoute = LegalShippingRouteImport.update({
            id: '/legal/shipping',path: '/legal/shipping',getParentRoute: () => rootRouteImport
          })
const LegalReturnsRoute = LegalReturnsRouteImport.update({
            id: '/legal/returns',path: '/legal/returns',getParentRoute: () => rootRouteImport
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/legal/privacy',path: '/legal/privacy',getParentRoute: () => rootRouteImport
          })
const JournalSlugRoute = JournalSlugRouteImport.update({
            id: '/journal/$slug',path: '/journal/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CareRoute: CareRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,ShopRoute: ShopRoute,SizeGuideRoute: SizeGuideRoute,JournalSlugRoute: JournalSlugRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalReturnsRoute: LegalReturnsRoute,LegalShippingRoute: LegalShippingRoute,LegalTermsRoute: LegalTermsRoute,ProductHandleRoute: ProductHandleRoute,JournalIndexRoute: JournalIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)